export default "__VITE_ASSET__75a48a75__"